import { useState, useEffect } from 'react';
import socketService from '@/services/socket';

export default function ConnectionStatus() {
  const [isConnected, setIsConnected] = useState(true);
  const [isReconnecting, setIsReconnecting] = useState(false);
  const [isAuthRetrying, setIsAuthRetrying] = useState(false);

  useEffect(() => {
    const unsubscribe = socketService.onConnectionChange((connected, reconnecting) => {
      setIsConnected(connected);
      setIsReconnecting(reconnecting);
    });

    const unsubscribeAuth = socketService.onAuthRetryChange((retrying) => {
      setIsAuthRetrying(retrying);
    });

    return () => {
      unsubscribe();
      unsubscribeAuth();
    };
  }, []);

  if (isConnected && !isReconnecting) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 dark:bg-yellow-600 text-brand-on-primary px-4 py-2 text-center text-sm font-medium shadow-lg">
      {isAuthRetrying ? (
        <div className="flex items-center justify-center gap-2">
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
          <span>Refreshing authentication, retrying connection…</span>
        </div>
      ) : isReconnecting ? (
        <div className="flex items-center justify-center gap-2">
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
          <span>Reconnecting to server...</span>
        </div>
      ) : (
        <span>⚠️ Connection lost. Attempting to reconnect...</span>
      )}
    </div>
  );
}
